import {createAsyncThunk, createSlice} from '@reduxjs/toolkit';

import APIUtils from '@livongo/utils/api';

export const PREFIX = 'Questions';
export const FETCH_PROGRAMS = `${PREFIX}/fetchPrograms`;
export const FETCH_QUESTIONS = `${PREFIX}/fetchQuestions`;
export const PROGRAM_UPSELL = `${PREFIX}/programUpsell`;

export const fetchPrograms = createAsyncThunk(
    FETCH_PROGRAMS,
    async (program, {dispatch, getState, rejectWithValue}) => {
        const {authToken} = getState().user;

        try {
            const response = await APIUtils.get(
                `/v1/users/me/programs/v2`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            const {generalQs, qualificationQs} = response.data;

            return {generalQs, qualificationQs};
        } catch (err) {
            const {data} = err;

            if (data.error) {
                return rejectWithValue({error: data.error});
            } else if (data.message) {
                return rejectWithValue({error: data.message});
            }
        }
    }
);

export const fetchQuestions = createAsyncThunk(
    FETCH_QUESTIONS,
    async (programs, {dispatch, getState, rejectWithValue}) => {
        const {authToken} = getState().user;

        try {
            const response = await APIUtils.get(
                `/v1/users/me/programs/questions/v2?programs=${programs}`,
                {},
                {
                    headers: {
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            const {generalQs, qualificationQs} = response.data;

            return {generalQs, qualificationQs};
        } catch (err) {
            const {data} = err;

            if (data.error) {
                return rejectWithValue({error: data.error});
            } else if (data.message) {
                return rejectWithValue({error: data.message});
            }
        }
    }
);

export const programUpsell = createAsyncThunk(
    PROGRAM_UPSELL,
    async (parameters, {dispatch, getState, rejectWithValue}) => {
        const {authToken} = getState().user;
        const basicAuthConfig = {
            headers: {
                Authorization: `Bearer ${authToken}`,
            },
        };

        try {
            const {program, answers} = parameters;
            const response = await APIUtils.post(
                'v1/users/me/programUpsell',
                {
                    program,
                    answers,
                },
                basicAuthConfig
            );

            // const {generalQs, qualificationQs} = response.data;

            return response.data;
        } catch (err) {
            const {data} = err;

            if (data.error) {
                return rejectWithValue({error: data.error});
            } else if (data.message) {
                return rejectWithValue({error: data.message});
            }
        }
    }
);

const initialState = {
    generalQs: [],
    qualificationQs: [],
    loading: false,
    error: null,
};

// Then, handle actions in your reducers:
const questionsSlice = createSlice({
    name: PREFIX,
    initialState,
    reducers: {
        // standard reducer logic, with auto-generated action types per reducer
    },
    extraReducers: {
        [fetchQuestions.pending]: (state, action) => {
            state.loading = true;
        },
        [fetchQuestions.fulfilled]: (state, action) => {
            const {generalQs, qualificationQs} = action.payload;

            state.qualificationQs = qualificationQs;
            state.generalQs = generalQs;
            state.loading = false;
        },
        [fetchQuestions.rejected]: (state, action) => {
            const {error} = action.payload;

            state.loading = false;
            state.error = error;
        },
        [programUpsell.pending]: (state, action) => {
            state.loading = true;
        },
        [programUpsell.fulfilled]: (state, action) => {
            state.loading = false;
        },
        [programUpsell.rejected]: (state, action) => {
            const {error} = action.payload;

            state.loading = false;
            state.error = error;
        },
    },
});

export default questionsSlice.reducer;
